import React, { FC } from 'react'

import { ReservationResponse } from '../../../common/validations/reservationSchema'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'
import { useAPIGetReservationsSuspense } from '../../api/apiHooks/useAPIGetReservations'

interface ReservationsDataLoaderProps {
  children: (
    reservations: ReservationResponse[],
    isLoading: boolean
  ) => React.ReactNode
}

export const ReservationsDataLoader: FC<ReservationsDataLoaderProps> = ({
  children,
}) => {
  const { currentContractId } = useCurrentContract()

  const { data: reservations = [], isLoading } =
    useAPIGetReservationsSuspense(currentContractId)

  return <>{children(reservations, isLoading)}</>
}
